import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index.js';
import i18n from '../plugins/vue-i18n.js';

import auth from './auth.js';
import main from './main.js';

Vue.use(VueRouter);

const router = new VueRouter({
    linkExactActiveClass: '',
    mode: 'history',
    routes: [
        ...auth,
        ...main,

        // Not Found
        {
            path: '*',
            component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue'),
            meta: {
                title: '',
            },
        },
    ],
});

// This callback runs before every route change, including on page load.
router.afterEach(to => {
    if (to.meta.title !== 'undefined') {
        store.commit('setPageTitle', to.meta.title ? i18n.t(to.meta.title) : '');
    }
});

export default router;
